
export const INDEX_ACCENT = "#8B7FD1";
export const INDEX_TRACK = "#F1EFFB";
export const INDEX_TEXT = "#1F2937";
export const INDEX_TEXT_MUTED = "#7C8797";
export const INDEX_DIVIDER = "#E4E8F0";
